import React from 'react';
import useInView from '../hooks/useInView';

const projects = [
  {
    title: 'Ollama Video Summarizer API',
    description: 'An API for an application sthat summarizes youtube videos using Ollama.',
    tech: ['Python', 'FastAPI', 'Ollama'],
    links: { github: 'https://github.com/romaingdr/OllamaYTSummaryAPI' },
    year: '2025',
  },
  {
    title: 'Lutra code editor',
    description: 'A code editor for Windows that uses 100% local AI to help you code.',
    tech: ['TypeScript', 'Electron', 'Monaco Editor'],
    links: { github: 'https://github.com/romaingdr/LutraCode' },
    year: '2026',
  },
];

const Projects = () => {
  const [ref, inView] = useInView();

  return (
    <section id="projects" className="py-20 md:py-32 px-6 md:px-12 max-w-6xl mx-auto border-t border-neutral-200 dark:border-white/10">
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
      >
        <div className="md:col-span-4">
          <h2 className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-4">
            03 / Projects
          </h2>
          <div className="h-px bg-neutral-200 dark:bg-white/20 w-12 hidden md:block"></div>
        </div>

        <div className="md:col-span-8 flex flex-col gap-12 md:gap-16 mt-4 md:mt-0">
          {projects.map((project, idx) => (
            <div key={idx} className="group relative">
              <div className="flex flex-col mb-4 md:mb-6">
                <h3 className="text-xl md:text-2xl font-semibold text-neutral-900 dark:text-white tracking-tight group-hover:text-neutral-600 dark:group-hover:text-neutral-300 transition-colors">
                  {project.title}
                </h3>
                <span className="text-xs md:text-sm font-mono text-neutral-500 mt-1 md:mt-2">
                  {project.year}
                </span>
              </div>
              <p className="text-base md:text-lg text-neutral-600 dark:text-neutral-400 mb-6 md:mb-8 leading-relaxed max-w-xl">
                {project.description}
              </p>

              <div className="flex flex-wrap gap-3 mb-6">
                {project.tech.map((t, i) => (
                  <span key={i} className="px-3 py-1 bg-neutral-100 dark:bg-white/5 text-neutral-700 dark:text-neutral-300 text-xs font-mono tracking-wide">
                    {t}
                  </span>
                ))}
              </div>

              <div className="flex items-center gap-6">
                {project.links.live && (
                  <a href={project.links.live} className="text-sm font-medium tracking-wide border-b border-neutral-300 dark:border-white/30 pb-0.5 hover:border-neutral-900 hover:text-neutral-900 dark:hover:border-white dark:hover:text-white transition-all text-neutral-700 dark:text-neutral-300">
                    Live Demo
                  </a>
                )}
                {project.links.github && (
                  <a href={project.links.github} className="text-sm font-medium tracking-wide text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors">
                    GitHub
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
